<template>
    <content-view class="waybillDetail">
        <div>
            <div class="bg-white pl32 pr32 pt24 pb32">
                <div class="waybillDetail-title pb24">完成进度</div>
                <div>
                    <a-steps :current="current">
                        <a-step
                        v-for="item in schedule"
                        :key="item.status"
                        >
                        <template slot="title">
                            {{item.name}}
                        </template>
                        <span slot="description">{{item.time}}</span>
                        </a-step>
                    </a-steps>
                </div>
            </div>
            <div class="bg-white pl32 pr32 pt24 mt24 pb24">
                <div class="waybillDetail-title pb24">完成进度</div>
                <div class="form form_3 pb16">
                    <div class="form-item">
                        <div class="form-item-key">运单号：</div>
                        <div class="form-item-val">{{recycling_info.serial}}</div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-key">总质量：</div>
                        <div class="form-item-val">{{recycling_info.transport_total_weight }}</div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-key">派送状态：</div>
                        <div class="form-item-val">{{ recycling_info.status | skipType}}</div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-key">运单时间：</div>
                        <div class="form-item-val">{{ recycling_info.create_time}}</div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-key">所需车辆：</div>
                        <div class="form-item-val">{{recycling_info.car_type }}</div>
                    </div>
                </div>
                <a-table
                    :columns="columns"
                    :dataSource="recycling_points"
                    bordered
                    :pagination=pagination
                    class=""
                >
                    <template
                        slot="scraps"
                        slot-scope="text, record"
                    >
                        <span
                        v-for="(item,index) in text"
                        :key="index"
                        >{{item.category_name+item.weight}}</span>
                    </template>
                </a-table>
            </div>
            <div class="bg-white pl32 pr32 pt24 mt24 pb24">
                <div class="waybillDetail-title pb24">送货信息</div>
                <div class="form form_3 pb16">
                <div class="form-item">
                    <div class="form-item-key">派送地点：</div>
                    <div class="form-item-val">{{sorting_info.sorting_address}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">完成时间：</div>
                    <div class="form-item-val">{{sorting_info.finish_time }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">收货人：</div>
                    <div class="form-item-val">{{ sorting_info.sorting_contacts}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">派送状态：</div>
                    <div
                    class="form-item-val"
                    style="color:#F5222D;"
                    >{{ sorting_info.status | skipType}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">备注：</div>
                    <div class="form-item-val">{{sorting_info.remarks }}</div>
                </div>
                </div>
                <div class="waybillDetail-map">
                <div class="waybillDetail-map-title">{{sorting_info.status | skipType}}</div>
                    <wh-map
                        ref="whMap"
                        :enableDraggable="true"
                    ></wh-map>
                </div>
                <div class="text-center mt32">
                    <a-button type="primary" class="mr8" @click="prev">返 回</a-button>
                </div>
            </div>
        </div>
    </content-view>
</template>
<script>
import WhMap from "@/components/common/wh-map.component";
export default {
    name: "waybillDetail",
    data() {
        return {
            id: "",
            recycling_info: {},
            recycling_points: [],
            sorting_info: {},
            schedule: [],
            status: [
                { status: 1, name: "待调度" },
                { status: 2, name: "待派单" },
                { status: 3, name: "待接单" },
                { status: 4, name: "运输中" },
                { status: 5, name: "已完成" },
                { status: 6, name: "异常" },
                { status: 7, name: "取消" }
            ],
            current: 0,
            columns: [
                {
                    title: "取货点",
                    customRender: (text, record, index) => `${index + 1}`
                },
                {
                    title: "取货位置",
                    dataIndex: "address_recycling"
                },
                {
                    title: "发货人",
                    dataIndex: "recycling_name"
                },
                {
                    title: "发货人电话",
                    dataIndex: "recycling_phone"
                },
                {
                    title: "取货时间",
                    dataIndex: "visiting_day"
                },
                {
                    title: "各品类重量(公斤)",
                    dataIndex: "scraps",
                    scopedSlots: { customRender: "scraps" }
                },
                {
                    title: "总重量(公斤)",
                    dataIndex: "total_weight"
                }
            ],
            pagination: false
        };
    },
    components: {
        WhMap
    },
    methods: {
        //获取详情
        getDetail(id) {
            this.$api.order.billDetails({ transport_id: id }).then(res => {
                this.current = res.data.recycling_info.status - 1;
                this.status.forEach((el, index) => {
                    // if (!this.current && !res.data.schedule[index]) {
                    //   console.log(index);
                    //   this.current = index - 1;
                    // }
                    el.time = !res.data.schedule[index]
                        ? "暂无"
                        : res.data.schedule[index];
                    this.schedule.push(el);
                });
                this.recycling_info = res.data.recycling_info;
                this.recycling_points = res.data.recycling_points;
                this.sorting_info = res.data.sorting_info;
                const { whMap } = this.$refs;
                if (res.data.recycling_points.length > 0) {
                    let point = new BMap.Point(
                        res.data.recycling_points[0].recycling_station_coordinate.lon,
                        res.data.recycling_points[0].recycling_station_coordinate.lat
                    );
                    whMap.setCity(point);
                }
                res.data.recycling_points.forEach(el => {
                    let point = {
                        lng: el.recycling_station_coordinate.lon,
                        lat: el.recycling_station_coordinate.lat
                    };
                    whMap.addMarker(point, {
                        autoViewport: false,
                        removeLastMarker: false,
                        showInfoWindow: false,
                        showDeleteButton: false,
                        //   clearOverlays: true
                    });
                });
            });
        },
        prev(){
            this.$router.push({
                name: "waybillList"
            });
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.getDetail(this.$route.query.id);
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.waybillDetail {
  &-title {
    color: $title-color-black-85;
    @include pxAndLh(16);
    font-weight: bold;
  }
  &-map {
    height: 536px;
    position: relative;
    &-title {
      position: absolute;
      top: 0;
      line-height: 56px;
      left: 0;
      right: 0;
      z-index: 99999;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>